import { combineReducers } from 'redux'
import user from './user/reducer'
import help from './help/reducer'
import messages from './messages/reducer'
import wizard from './wizard/reducer' 
import { admin } from './admin/reducer'
import { advisor } from './advisor/reducer' 
import { reports } from './reports/reducer'
import { bmc } from './bmc/reducer'
import rnc from './rnc/reducer'
import { apps } from './apps/reducer'
import subscription from './subscription/reducer'

export const reducer = combineReducers({
	user,
	help,
	messages,
	wizard,
	admin,
	advisor,
  reports,
	bmc,
	subscription,
	rnc,
	apps
})
